import React, { useCallback, useEffect, useRef, useState } from 'react';

export default function SkeletonImage({
    src,
    alt = '',
    className = '',
    frameClassName = '',
    loading = 'lazy',
}) {
    const imgRef = useRef(null);
    const [ready, setReady] = useState(false);
    const [failed, setFailed] = useState(false);

    const markReady = useCallback(() => {
        setReady(true);
    }, []);

    useEffect(() => {
        setReady(false);
        setFailed(false);

        const img = imgRef.current;
        if (img?.complete && img.naturalWidth > 0) {
            setReady(true);
        }
    }, [src]);

    return (
        <span
            className={[
                'gs-skeleton-frame',
                frameClassName,
                ready ? 'is-ready' : '',
                failed ? 'is-failed' : '',
            ].filter(Boolean).join(' ')}
        >
            {!ready && !failed && (
                <span className="gs-skeleton-shimmer" aria-hidden="true" />
            )}
            {!failed && src ? (
                <img
                    ref={imgRef}
                    src={src}
                    alt={alt}
                    loading={loading}
                    className={className}
                    onLoad={markReady}
                    onError={() => {
                        setFailed(true);
                        setReady(true);
                    }}
                />
            ) : null}
            {failed && (
                <span className="gs-skeleton-fallback" aria-hidden="true" />
            )}
        </span>
    );
}
